export const INIT = 1;
export const LOADING = 2;
export const FAILED = 3;
export const LOADED = 4;
